module.exports = __webpack_public_path__ + "static/media/new_error.421e97ce.svg";